import { create } from 'zustand'

// frontend-restructuring §1a — the global "a save just landed" indicator.
//
// A POST/PUT/DELETE completing anywhere in the app flips `blink` through a short
// on-off-on-off sequence (green = ok, red = failed); `Menu2` renders the status dot from it.
// The sequence timer lives at module scope so the store owns the whole animation regardless
// of which component is subscribed — this used to be duplicated `setInterval` logic in both
// `Home.jsx` and `Menu2.jsx`, fed by a `server-save-action` window CustomEvent.
//
// Written by `app/savePulse.js` (the module-level fetch wrapper). Never by a component.

const STEP_MS = 300
let seqTimer = null

export const useSaveStatusStore = create((set) => ({
  blink: null, // 'green' | 'red' | null

  pulse: (success) => {
    const color = success ? 'green' : 'red'
    if (seqTimer) clearInterval(seqTimer)
    let n = 0
    set({ blink: color })
    seqTimer = setInterval(() => {
      n += 1
      if (n === 1) set({ blink: null })
      else if (n === 2) set({ blink: color })
      else if (n === 3) set({ blink: null })
      else {
        clearInterval(seqTimer)
        seqTimer = null
      }
    }, STEP_MS)
  },
}))
